import { absolutePath } from "../../absolutePath";
import { accessGroupsMigration } from "./accessGroupsMigration";
import { affiliates } from "./affiliates";

interface PaywallsFnProps {
  chargeProcessorId?: string | number;
  couponCode?: string | number;
  id?: string | number;
  params?: Record<string, unknown>;
  subscriptionProcessorId?: string | number;
}

export const paywalls = {
  exports: {
    create: () => absolutePath("admin/paywalls/exports"),
  },
  subscriptions: {
    index: ({ params = {} }: PaywallsFnProps = {}) =>
      absolutePath("admin/paywalls/subscriptions", params),
    create: () => absolutePath("admin/paywalls/subscriptions"),
    refundOptions: ({ subscriptionProcessorId }: PaywallsFnProps = {}) =>
      absolutePath(
        `admin/paywalls/subscriptions/${subscriptionProcessorId}/refund_options`,
      ),
    cancellations: ({
      subscriptionProcessorId,
      params = {},
    }: PaywallsFnProps = {}) =>
      absolutePath(
        `admin/paywalls/subscriptions/${subscriptionProcessorId}/cancellations`,
        params,
      ),
    coupons: {
      create: ({ subscriptionProcessorId }: PaywallsFnProps = {}) =>
        absolutePath(
          `admin/paywalls/subscriptions/${subscriptionProcessorId}/coupons`,
        ),
      delete: ({ subscriptionProcessorId }: PaywallsFnProps = {}) =>
        absolutePath(
          `admin/paywalls/subscriptions/${subscriptionProcessorId}/coupons`,
        ),
      preview: ({
        subscriptionProcessorId,
        couponCode,
      }: PaywallsFnProps = {}) =>
        absolutePath(
          `admin/paywalls/subscriptions/${subscriptionProcessorId}/coupons/preview`,
          couponCode ? { coupon_code: couponCode } : {},
        ),
    },
  },
  charges: {
    index: ({ params = {} }: PaywallsFnProps = {}) =>
      absolutePath("admin/paywalls/charges", params),
    refunds: ({ chargeProcessorId, params = {} }: PaywallsFnProps = {}) =>
      absolutePath(
        `admin/paywalls/charges/${chargeProcessorId}/refunds`,
        params,
      ),
  },
  taxSettings: {
    show: () => absolutePath("admin/paywalls/tax_settings"),
    update: () => absolutePath("admin/paywalls/tax_settings"),
  },
  paymentMethodPreferences: {
    show: () => absolutePath("admin/paywalls/payment_method_preferences"),
    update: () => absolutePath("admin/paywalls/payment_method_preferences"),
  },
  affiliates,
  accessGroupsMigration,
};
